import { getPath, getRoot } from 'core/router';
import { bindEmitterMethod } from 'helpers/bind';
import InternalPage from 'navigation/pages/InternalPage';
import ProductCard from 'sections/product/partials/ProductCard';
import { forceArray } from 'navigation/component/Component';
class Wishlist extends InternalPage {
    initialized() {
        super.initialized();
    }
    getModulesMap() {
        return {
            productCards: ['.product-card', ProductCard]
        };
    }
    getModuleParams(el, componentConstructor) {
        return {
            parent: this.parent,
            isWishlist: true
        };
    }
    bindModules() {
        super.bindModules();
    }
    bindEvents(add) {
        const emitterMethod = bindEmitterMethod(add);
        forceArray(this.modules.productCards).forEach((card) => {
            card[emitterMethod]('wishlist:toggle', this.onToggleWishlist);
        });
    }
    onToggleWishlist = (e) => {
        const parent = this.parent;
        let link = getPath();
        link = link.replace(getRoot(), '');
        if (e.xhr.response.querySelector('.page'))
            parent.modules.content.inject(link, e.xhr);
        else
            parent.modules.content.load(link);
    };
}
export default Wishlist;
